import React, { useEffect, useState } from "react"

import AbstractGraphSelectionArea from "../../../resources/AbstractGraphSelectionArea"
import { withRunEventLabelState } from "../../../../../components/shared_components_registration"
import { isValidDate } from "../../../../utils"

const RunEventLabelSelectionLayer = ({
  x,
  y,
  y2,
  margin,
  fullY,
  zoomKey,
  graphKey = {},

  // From RunLabelConfigProvider
  addingRunEventLabel,
  setAddingRunEventLabel,
  setNewLabelSelection,
  eventLabelColor,
}) => {
  const onSelect = (xChanged, _, __, minX, maxX, ___) => {
    if (xChanged) {
      setNewLabelSelection &&
        setNewLabelSelection({
          runID: zoomKey,
          min: isValidDate(minX) ? minX : parseFloat(minX.toFixed(3)),
          max: isValidDate(maxX) ? maxX : parseFloat(maxX.toFixed(3)),
          graphKey: structuredClone(graphKey),
        })
      setAddingRunEventLabel && setAddingRunEventLabel(false)
    }
  }

  const [selecting, setSelecting] = useState(false)
  useEffect(() => {
    setSelecting(addingRunEventLabel)
  }, [addingRunEventLabel])

  return (
    <AbstractGraphSelectionArea
      x={x}
      y={y}
      y2={y2}
      margin={margin}
      fullY={fullY}
      onSelect={onSelect}
      selecting={selecting}
      color={eventLabelColor}
      label={"Run Event Label"}
      canSelectX
    />
  )
}

export default withRunEventLabelState(RunEventLabelSelectionLayer)
